module.exports = __webpack_public_path__ + "static/media/20-10.5ee150f3.mp3";